<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/studentList'}">在读学员</el-breadcrumb-item>
      <el-breadcrumb-item>1对1排课</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>课程信息</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="1对1班级" prop="teacher">
                <el-select v-model="fromData.teacher" placeholder="请选择">
                  <el-option
                    v-for="item in teacherList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="所属课程" prop="teacher">
                <el-select v-model="fromData.teacher" placeholder="请选择">
                  <el-option
                    v-for="item in teacherList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
           </el-row>
           <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="单课时长" prop="phoneNum">
                <el-input v-model="fromData.phoneNum"></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="12">
              <el-form-item label="上课教室" prop="phoneNum">
                <el-input v-model="fromData.phoneNum"></el-input>
              </el-form-item>
            </el-col>
           </el-row>
           <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="上课学员" prop="contact">
                <el-input v-model="fromData.contact"></el-input>
              </el-form-item>
            </el-col>
           </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 安排课表 -->
    <el-card class="mt20">
      <div slot="header" class="clearfix">
        <span>安排课表</span>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="循环排课" name="first">
            <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="重复方式" prop="teacher">
                    <el-select v-model="fromData.teacher" placeholder="请选择">
                      <el-option
                        v-for="item in teacherList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                 <el-col :span="12">
                  <el-form-item label="开课日期" prop="teacher">
                    <el-date-picker
                      v-model="fromData.birthday"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="上课时间" prop="time">
                      <el-time-picker
                        is-range
                        v-model="fromData.time"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                      </el-time-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
          </el-tab-pane>
          <el-tab-pane label="日历排课" name="second">日历排课</el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <!-- 选择老师 -->
    <el-card class="mt20">
      <div slot="header" class="clearfix">
        <span>选择老师</span>
      </div>
      <div>
        <el-form label-width="160px" :rules="rules" ref="fromData" :model="fromData" >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="授课老师" prop="teacher">
                <el-select v-model="fromData.teacher" placeholder="请选择">
                  <el-option
                    v-for="item in teacherList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
           </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="footer-nav">
          <el-button type="primary" @click="submitForm('fromData')">确定</el-button>
          <el-button @click="resetForm('fromData')">取消</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        fromData:{
          name:'',
          gender:'1',
          time:[]
        },
        // 学管师列表
        teacherList:[
          {
            value:'1',
            label:'陈老师'
          },
          {
            value:'2',
            label:'王老师'
          }
        ],
        activeName:'first',
        // 校验规则
        rules: {
          name: [
            { required: true, message: '请输入学生姓名', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          phoneNum:[
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
          ],
          contactNum:[
            { required: true, message: '请输入紧急人电话', trigger: 'blur' },
            { pattern: /^1[34578]\d{9}$/, message: '请输入正确的紧急人电话', trigger: 'blur' }
          ],
        }
      };
    },
    created() {
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$router.push("/studentList");
      },
      // tab切换
      handleClick(tab, event) {
        console.log(tab, event);
      }
  },
};
</script>

<style lang="less" scoped>
  /deep/ .el-upload__input{
    display: none;
  }
</style>
